import React from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  IconButton,
  Grid,
  Divider,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const HeadSx = {
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0%",
  verticalAlign: "middle",
  color: "rgba(15, 15, 15, 1)", // or use theme variable if defined
};
const DescriptionSx = {
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0%",
  verticalAlign: "middle",
  color: "rgba(96, 96, 96, 1)", // or use "var(--color-grey-38)"
};

const LanguageRegionSettings = () => {
  const languages = ["English-UK", "English-US", "Hindi", "Spanish"];
  const [language, setLanguage] = React.useState("English-UK");

  return (
    <Box
      p={3}
      sx={{
        width: "100%",
        height: "100vh",
        border: "1px solid rgba(221, 221, 221, 1)",
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        mt: 1,
      }}
    >
      {/* Preferred Language */}
      <Box mb={3}>
        <Grid container alignItems="flex-start" justifyContent="space-between">
          <Grid item xs={12} md={8}>
            <Typography sx={HeadSx}>Preferred Language</Typography>
            <Typography sx={DescriptionSx}>
              Select the language you'd like to use across the platform. Your
              choice will personalize menus, messages, and system notifications.
            </Typography>
          </Grid>

          <Grid item xs={12} md={2}>
            <TextField
              select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              size="small"
              fullWidth
              sx={{ mt: { xs: 1, md: 0 } }}
            >
              {languages.map((lang) => (
                <MenuItem key={lang} value={lang}>
                  {lang}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </Box>
      <Divider sx={{ height: 2, backgroundColor: "rgba(221, 221, 221, 1)" }} />
      {/* Time Zone */}
      <Box mb={3} mt={2}>
        <Grid container alignItems="flex-start" justifyContent="space-between">
          <Grid item xs={12} md={8}>
            <Typography sx={HeadSx}>Time Zone</Typography>
            <Typography sx={DescriptionSx}>
              Set your local time zone so deadlines, messages, and campaign
              schedules appear correctly for you.
            </Typography>
          </Grid>

          <Grid item xs={12} md={2}>
            <TextField
              size="small"
              fullWidth
              value="Ahmedabad, India – GMT+5:30"
              disabled
              sx={{ mt: { xs: 1, md: 0 } }}
            />
          </Grid>
        </Grid>
      </Box>
      <Divider sx={{ height: 2, backgroundColor: "rgba(221, 221, 221, 1)" }} />

      {/* Regional Preferences */}
      <Box mb={3} mt={2}>
        <Grid container alignItems="flex-start" justifyContent="space-between">
          <Grid item xs={12} md={8}>
            <Typography sx={HeadSx}>Regional Preferences</Typography>
            <Typography sx={DescriptionSx}>
              Customize your content and discovery experience based on your
              location and target regions.
            </Typography>
          </Grid>

          <Grid item xs={12} md={2}>
            <TextField
              size="small"
              fullWidth
              value="Ahmedabad, India"
              disabled
              sx={{ mt: { xs: 1, md: 0 } }}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default LanguageRegionSettings;
